// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__4Ygqp","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3F2n_"};